import {
  ApiPerformanceReviewEdit,
  ApiPerformanceReviewStatus,
} from "@/types/performance-review.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { PerformanceReviewEditPageStep } from "@/pages/talent/performance-reviews/edit/performance-review-edit.ts";

export interface PerformanceReviewEditSidebarProps {
  step: PerformanceReviewEditPageStep;
  review?: ApiPerformanceReviewEdit;
}

export const PerformanceReviewEditSidebar = ({
  step,
  review,
}: PerformanceReviewEditSidebarProps) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      step: PerformanceReviewEditPageStep.details,
      title: t("common:details"),
    },
    {
      step: PerformanceReviewEditPageStep.reviewers,
      title: t("performance_review:reviewers"),
    },
    {
      step: PerformanceReviewEditPageStep.forms,
      title: t("performance_review:configure_forms"),
    },
    {
      step: PerformanceReviewEditPageStep.settings,
      title: t("performance_review:reviewers_settings"),
    },
    {
      step: PerformanceReviewEditPageStep.invitation,
      title: t("performance_review:invitation_settings"),
    },
    {
      step: PerformanceReviewEditPageStep.ratings,
      title: t("performance_review:ratings"),
    },
    {
      step: PerformanceReviewEditPageStep.notifications,
      title: t("common:notifications"),
    },
  ];
  const currentStepIndex = menuItems.findIndex((item) => item.step === step);

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item, itemIndex) => {
        const className = step === item.step ? "text-default" : "text-secondary";
        const isLinkAvailable =
          review &&
          (review.status !== ApiPerformanceReviewStatus.draft || itemIndex < currentStepIndex);

        if (!isLinkAvailable) {
          return (
            <Text key={item.step} className={className}>
              {item.title}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item.step}
            to={`/performance-reviews/${review.id}/setup/${item.step}`}
            variant={"plain"}
            className={className}
          >
            <Text>{item.title}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
